import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import request from '@/utils/request';
import API from '@/config/api';
import type { ProcessJob, ImportJob } from '@/types/log.types';
import {
  fetchAiJobsRequest, fetchAiJobsSuccess, fetchAiJobsFailure,
  searchAiJobsRequest, searchAiJobsSuccess, searchAiJobsFailure,
  fetchImportJobsRequest, fetchImportJobsSuccess, fetchImportJobsFailure,
  searchImportJobsRequest, searchImportJobsSuccess, searchImportJobsFailure,
} from './processesSlice';

function* handleFetchAiJobs(action: PayloadAction<{ page: number; limit: number; search?: string; status?: string }>) {
  try {
    const res: { data: { data: { list: ProcessJob[]; totalRecords: number } } } = yield call(request.get, API.AI_THEMATIC_JOBS, { params: action.payload });
    yield put(fetchAiJobsSuccess({ list: res.data.data.list, totalCount: res.data.data.totalRecords }));
  } catch (e: unknown) { yield put(fetchAiJobsFailure(e instanceof Error ? e.message : 'Failed')); }
}

function* handleSearchAiJobs(action: PayloadAction<{ search: string }>) {
  try {
    const res: { data: { data: { list: ProcessJob[]; totalRecords: number } } } = yield call(request.get, API.AI_THEMATIC_JOBS_SEARCH, { params: action.payload });
    yield put(searchAiJobsSuccess({ list: res.data.data.list, totalCount: res.data.data.totalRecords }));
  } catch (e: unknown) {
    console.error('searchAiJobs failed', e);
    yield put(searchAiJobsFailure(e instanceof Error ? e.message : 'Search failed'));
  }
}

function* handleFetchImportJobs(action: PayloadAction<{ page: number; limit: number; search?: string; status?: string }>) {
  try {
    const res: { data: { data: { list: ImportJob[]; totalRecords: number } } } = yield call(request.get, API.AI_IMPORT_JOBS, { params: action.payload });
    yield put(fetchImportJobsSuccess({ list: res.data.data.list, totalCount: res.data.data.totalRecords }));
  } catch (e: unknown) { yield put(fetchImportJobsFailure(e instanceof Error ? e.message : 'Failed')); }
}

function* handleSearchImportJobs(action: PayloadAction<{ search: string }>) {
  try {
    const res: { data: { data: { list: ImportJob[]; totalRecords: number } } } = yield call(request.get, API.AI_IMPORT_JOBS_SEARCH, { params: action.payload });
    yield put(searchImportJobsSuccess({ list: res.data.data.list, totalCount: res.data.data.totalRecords }));
  } catch (e: unknown) {
    console.error('searchImportJobs failed', e);
    yield put(searchImportJobsFailure(e instanceof Error ? e.message : 'Search failed'));
  }
}

export default function* processesSaga() {
  yield takeLatest(fetchAiJobsRequest.type, handleFetchAiJobs);
  yield takeLatest(searchAiJobsRequest.type, handleSearchAiJobs);
  yield takeLatest(fetchImportJobsRequest.type, handleFetchImportJobs);
  yield takeLatest(searchImportJobsRequest.type, handleSearchImportJobs);
}
